import DialogPage from "../DialogPage";
import {Image, View} from "react-native";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {RowSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import {CardView} from "../components/CardView";
import GamesList from "../../../components/data-components/GamesList";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";

export default function Games(props: any) {

    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const appFunctions = useContext(AppFunctionsContext);

    return <DialogPage {...props} header={"سرگرمی"}>
        <Text style={{textAlign: "center"}} color={colors.get("primaryColor") as string} size={12} weight={600}>
            تا سفارشتون حاضر میشه بازی کنین!
        </Text>
        <GamesList renderItem={(item) => {
            return <CardView scheme="flat" onPress={() => {
                appFunctions.appNavigator.toGameScreen(item.item);
            }}>
                <View style={{flexDirection: "row", alignItems: "center"}}>
                    <Image source={{uri: item.item.icon}} style={{width: 35, height: 35, borderRadius: 8}}/>
                    <RowSpace/>
                    <Text style={{flexGrow: 1, textAlign: "center"}} weight={700}>{item.item.name}</Text>
                </View>
            </CardView>
        }}/>
    </DialogPage>
}
